<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import Input from "@/components/c-input";
import Button from "@/components/c-button";
import moment from 'moment'
import { itemService } from "../../../../services/inventoryservice/item.service";


/* eslint-disable no-console */
export default {
  page: {
    title: "Payment-Detail Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Input,
    Select, 
    Search,
  },
  data() {
    return {
      title: "Detail Payment Report",
      data: [],
      date: '',
      projects: {},
      categories: {},
      suppliers: {},
      types: {},
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      valueKey: '',
      valueStart: this.$moment().clone().startOf('month').format('YYYY-MM-DD'),
      valueEnd: this.$moment().clone().endOf('month').format('YYYY-MM-DD'),
      valueCategory: 0,
      valueType: 0,
      valueSupplier: 0

    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    // this.loadingpropertyGroupData(this.dataProjectId);
    
  },
  methods: {
  

    loadingData: function() {
      
      itemService.itemListReport({
        key: this.valueKey,
        start: this.valueStart,
        end: this.valueEnd
      })
        .then(response => {
          this.data = response.data.list;
          this.categories = response.data.categories;
          this.types = response.data.types;
          this.suppliers = response.data.suppliers;

          // console.log(JSON.stringify(response.data.list));
          console.log(JSON.stringify({
              key: this.valueKey,
              start: this.valueStart,
              end: this.valueEnd
            }));
      });
    },

    submitSearch: function() {

      let data = {
        key: this.valueKey,
        start: this.valueStart,
        end: this.valueEnd,
        type: this.valueType,
        category: this.valueCategory,
        supplier: this.valueSupplier
      };

      // console.log(JSON.stringify(data));

      itemService.itemListReport(data)
        .then(response => {
          this.data = response.data.list;
          this.categories = response.data.categories;
          this.types = response.data.types;
          this.suppliers = response.data.suppliers;

          // console.log(JSON.stringify(response.data));
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = '.0000';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    print() {
      window.print();
    },
    
  },
  computed: {
    totalPiad() {
      return this.data.reduce(function (sum, item) {
        return sum + item.paid
      }, 0)
    },
    totalIntegerPay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.integer_pay
      }, 0)
    },
    totalInterest() {
      return this.data.reduce(function (sum, item) {
        return sum + item.interest
      }, 0)
    },
    totalPrinciplePay() {
      return this.data.reduce(function (sum, item) {
        return sum + item.principal_pay
      }, 0)
    },
    totalPenalty() {
      return this.data.reduce(function (sum, item) {
        return sum + item.penalty
      }, 0)
    },

    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('item.item-list')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              <div class="col-sm-2">
                <label>{{$t('general.search')}}</label>
                <Input 
                  :type="'text'"
                  :id="'data_search'"
                  :placeholder="$t('item.text')+' / '+$t('general.notation')"
                  @enter="submitSearch"
                  v-model="valueKey"
                /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('supplier.text')}}</label>
                <Search
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: suppliers}"
                  v-model="valueSupplier"
                /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('category.text')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: categories}"
                  v-model="valueCategory"
                /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('invoice.type')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: types}"
                  v-model="valueType"
                /> 
              </div>
              <div class="col-sm-1">
                <label>{{$t('general.start-date')}}</label>
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="valueStart"
                /> 
              </div>
              <div class="col-sm-1">
                <label>{{$t('general.end-date')}}</label>
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="valueEnd"
                /> 
              </div>
              <div class="col-sm-2">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="40%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 078 55 40 77 | 015 55 40 77, Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.text')+$t('item.item-list')}}</u></p>
                    <p class="khb"><u>ប្រចាំខែ: {{this.dateFormat(valueStart)}} - {{this.dateFormat(valueEnd)}}</u></p>
                    <!-- <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p> -->
                </td>
              </tr>
              
            </table>
            <br/>
           <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="khm thead">
                  <th width="50">{{$t('general.number')}}</th>
                  <th class="khm" width="150">{{$t('general.date')}}</th>
                  <th class="khm" >{{$t('invoice.text')}}</th>
                  <th class="khm" >{{$t('supplier.text')}}</th>
                  <th class="khm" >{{$t('item.text')}}</th>
                  <th class="khm" >{{$t('category.text')}}</th>
                  <th class="khm" >{{$t('invoice.type')}}</th>
                  <th class="khm" >{{$t('general.unit-name')}}</th>
                  <th class="khm text-right" width="150">{{$t('item.quantity')}}</th>
                  <th class="khm text-right" width="150">{{$t('item.price')}}</th>
                  <th class="khm text-right" width="150">{{$t('invoice.amount')}}</th>
                </tr>
              <tbody>
                <tr v-for="(item, index) in data" :key="index" >
                  <td>{{index + 1}}</td>
                  <td>{{dateFormat(item.transaction_date)}}</td>
                  <td>{{item.number}}</td>
                  <td>{{item.supplier}}</td>
                  <td>{{item.name}}</td>
                  <td>{{item.category}}</td>
                  <td>{{item.type}}</td>
                  <td>{{item.unit}}</td>
                  <td class="text-right">{{item.qantity}}</td>
                  <td class="text-right">{{formatCurrency(item.price)}}</td>
                  <td class="text-right">{{formatCurrency(item.qantity * item.price)}}</td>
                </tr>
                <tr class="khm thead">
                  <td style="color: white;" colspan="8">{{$t('invoice.total')}}</td>
                  <td class="text-right" style="color: white;">{{(data.reduce((acc, item) => acc + item.qantity, 0))}}</td>
                   <td></td>
                  <td class="text-right" style="color: white;">{{formatCurrency(data.reduce((acc, item) => acc + (item.qantity * item.price), 0))}}</td>
                </tr>
              </tbody>
                

            </table>
          </div>  
          <div class="row mt-3 report-table">
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                  <br><br>

                  <p>លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <br><br>

                  <p>លឹម ទ្រី</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                  <br><br>

                  <p>សាយនី យូស៊ន់</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              
              <div class="col-3 mt-5">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br><br>

                  <p></p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col-3">
                <center>
                  <p class="align-right">{{$t('report.income_expense.date')}} {{dateFormat(valueStart)}}<br>អ្នកធ្វើរបាយការណ៍</p>
                    <br><br>
                  <p class="mt-5">{{this.user.name}}</p>

                  </center>
              </div>
          </div>
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>